'use client';
import { useEffect } from 'react';

import useAuth from '@/hook/use-auth.hook';
import { useRouter } from 'next/navigation';
import { useWindowDimensions } from '@/hook';
import { DimensionsTargets } from '@/hook/use-window-width.hook';
import { useTranslation } from '@/hook';
import { authTokenKey } from '@/constants';
import { authStorage } from '@/classes/SylndrStorage';

export default function AccountGuard({ children }: { children: JSX.Element }) {
    const { checkForTokenAndDecode } = useAuth();
    const router = useRouter();
    const { i18n } = useTranslation();
    const { IS_DESKTOP } = useWindowDimensions(DimensionsTargets.MOBILE);
    useEffect(() => {
        const executeAccountGuardLogic = () => {
            const returnedName = checkForTokenAndDecode();

            const token = authStorage.getItem(authTokenKey);

            if (!token || !returnedName) {
                router.push(`/${i18n.language}/register`);
                return;
            } else {
                if (IS_DESKTOP) {
                    router.push(`/${i18n.language}`);
                    return;
                }
            }
        };
        executeAccountGuardLogic();
    }, [IS_DESKTOP]);

    return (
        <>
            <>{children}</>
        </>
    );
}
